/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Topics_DescInputs */



/**
* | output |
* | --- |
* | "The fixed structure of every conversation of this type. Each topic becomes a section in your preparation and in your report." |
*
* @param {Settings_Template_Topics_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_topics_desc = /** @type {((inputs?: Settings_Template_Topics_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Topics_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De vaste structuur van elk gesprek van dit type. Elk onderwerp wordt een sectie in je voorbereiding en in je verslag.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La structure fixe de chaque conversation de ce type. Chaque sujet devient une section de votre préparation et de votre compte rendu.")
	return /** @type {LocalizedString} */ ("The fixed structure of every conversation of this type. Each topic becomes a section in your preparation and in your report.")
});